<template>
  <div class="login_cont_box">
    <div class="login_data">
      <img class="close" src="@/assets/close_icon.png" @click="closeLogin" />
      <div class="tabs">
        <div class="tab" :class="{'active': tabActive==1}" @click="formData={}; tabActive=1">工会登录</div>
        <div class="tab" :class="{'active': tabActive==2}" @click="formData={}; tabActive=2">企业登录</div>
      </div>
      <div class="form_cont" v-if="tabActive==1">
        <ul>
          <li class="user"><input type="text" v-model="formData.account" placeholder="请输入账号" /></li>
          <li class="pass"><input type="password" autocomplete="new-password" v-model="formData.password" placeholder="请输入密码" /></li>
        </ul>
        <div class="btn" @click="submitBtn()">登录</div>
        <p class="tips">账号与广东省总工会劳模管理平台账号一致</p>
      </div>
      <div class="form_cont" v-if="tabActive==2">
        <ul>
          <li class="phone"><input type="number" v-model="formData.account" placeholder="请输入手机号" /></li>
          <li class="pass"><input type="password" autocomplete="new-password" v-model="formData.password" placeholder="请输入密码" /></li>
        </ul>
        <div class="btn" @click="submitBtn()">登录</div>
        <p class="tips">账号与广东省总工会劳模管理平台账号一致</p>
      </div>
    </div>
  </div>
</template>
<script>
import { mapMutations } from "vuex";
export default {
  name: "list",
  components: {},

  data() {
    return {
      tabActive: 1,
      formData: {}
    };
  },
  mounted() { },
  methods: {
    ...mapMutations(['CloseLoginModal', 'ShowTipModal', 'ClearUserInfo']), //登录弹窗

    // 登录按钮
    submitBtn() {
      if (!this.formData.account) {
        if(this.tabActive == 1){
          return this.$message.error('请输入账号');
        }else{
          return this.$message.error('请输入手机号');
        }
      }

      if (!this.formData.password) {
        return this.$message.error('请输入密码')
      }

      let formData = new FormData()
      formData.append('account', this.formData.account);
      formData.append('password', this.formData.password);
      formData.append('type', this.tabActive);

      this.$axios.post(`/user/login`, formData).then(res => {
        if (res.code == 1) {
          localStorage.setItem('userInfo', JSON.stringify(res.data.userinfo))
          localStorage.setItem('auth', res.data.userinfo.token)
          this.CloseLoginModal()
          location.reload()
        } else {
          this.$message.error(res.msg)
        }
      })
    },


    // 关闭登录弹框
    closeLogin() {
      for (let i in this.formData) {
        this.formData[i] = ''
      }
      this.CloseLoginModal()
    }
  },
};
</script>
<style scoped lang="scss">
@import "@/utils/common.scss";
</style>